import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { withFormik, Field } from "formik";
import { withTranslation } from "react-i18next";
import {
  dataModel,
  validationDataModel,
  setInitialValues,
} from "./workingPartFilter.data.form";
import InputText from "../../../utils/InputText";
import { MONTHS } from "../../../../constants/index";
import InputSelect from "../../../utils/InputSelect";
// import InputAutocomplete from "../../../utils/InputAutocomplete";

const WorkingPartFilterForm = (props) => {
  const { t, handleSubmit, onClean, onFilterEmployee } = props;

  const currentYear = new Date().getFullYear();
  const years = [];
  for (let index = 0; index < 5; index++) {
    years.push({
      code: currentYear - index,
      label: currentYear - index,
    });
  }

  const renderListEmployee = (item) => {
    return `${item.companyCode} - ${item.name}`;
  };

  return (
    <div className="row no-margin">
      <div className="col-12 mb-3">
        <div className="accordion" id="stopFilter">
          <div className="accordion-item">
            <h2 className="accordion-header" id="flush-headingOne">
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#flush-collapseOne"
                aria-expanded="false"
                aria-controls="flush-collapseOne"
              >
                {t("forms.workingPartSnap.filter")}
              </button>
            </h2>
            <div
              id="flush-collapseOne"
              className="accordion-collapse collapse"
              aria-labelledby="flush-headingOne"
              data-bs-parent="#stopFilter"
            >
              <div className="accordion-body">
                <form
                  className="form-horizontal"
                  onSubmit={handleSubmit}
                  autoComplete="off"
                >
                  {/* año */}
                  <div className="row">
                    <div className="col-3">
                      <Field
                        id="year"
                        name="year"
                        labelField={t("forms.workingPartSnap.labels.year")}
                        component={InputSelect}
                        placeholder=""
                        optionLabel="label"
                        optionValue="code"
                        options={years.map((item) => ({
                          ...item,
                          label: t(item.label),
                        }))}
                        classNamePrefix="dark"
                        addOptionEmpty
                      />
                    </div>
                    {/* mes */}
                    <div className="col-3">
                      <Field
                        id="month"
                        name="month"
                        labelField={t("forms.workingPartSnap.labels.month")}
                        component={InputSelect}
                        placeholder=""
                        optionLabel="label"
                        optionValue="code"
                        options={MONTHS.map((item) => ({
                          ...item,
                          label: t(item.label),
                        }))}
                        classNamePrefix="dark"
                        addOptionEmpty
                      />
                    </div>
                    {/* empleado (Autocompletable) */}
                    {/* <div className="col-3">
                      <Field
                        id="employeeID"
                        name="employeeID"
                        className="form-control"
                        labelField={t(
                          "forms.workingPartSnap.labels.employeeID"
                        )}
                        component={InputText}
                        placeholder=""
                        classNamePrefix="dark"
                      />
                    </div> */}
                    <div className="col-3">
                      <Field
                        id="employeeName"
                        name="employeeName"
                        className="form-control"
                        labelField={t(
                          "forms.workingPartSnap.labels.employeeName"
                        )}
                        component={InputText}
                        placeholder=""
                        classNamePrefix="dark"
                      />
                    </div>
                    {/* <div className="col-12 col-md-3">
                      <Field
                        id="employeeID"
                        className="form-control"
                        labelField={t(
                          "forms.workingPartSnap.labels.employeeID"
                        )}
                        name="employeeID"
                        component={InputAutocomplete}
                        fieldType="text"
                        onSearch={onFilterEmployee}
                        optionValue="employeeID"
                        optionLabel="companyCode"
                        textButtonReset={t("clear")}
                        renderItems={renderListEmployee}
                      />
                    </div> */}
                  </div>
                  <div className="row mt-3">
                    <div className="col-12 d-flex justify-content-end">
                      <button
                        type="submit"
                        className="btn btn-lg btn-primary me-2"
                      >
                        <i className="fas fa-search"></i>
                      </button>
                      <button
                        type="button"
                        className="btn btn-lg btn-secondary"
                        onClick={() => onClean(props.resetForm)}
                        title={t("cleanFilter")}
                      >
                        <i className="fas fa-trash"></i>
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

WorkingPartFilterForm.propTypes = {
  handleSubmit: PropTypes.func,
  t: PropTypes.any,
  onClean: PropTypes.func,
};

const WorkingPartFilterFormF = withFormik({
  mapPropsToValues: (props) => {
    if (props.initialValues) {
      return setInitialValues(props.initialValues);
    }
    return dataModel;
  },
  validationSchema: validationDataModel,
  handleSubmit: (values, { props, resetForm }) => {
    props.onSubmit(values, resetForm);
  },
  enableReinitialize: true,
  displayName: "WorkingPartFilterForm",
})(withTranslation()(WorkingPartFilterForm));

export default WorkingPartFilterFormF;
